import styled, { css } from 'styled-components';

import { BaSeTheme } from '@base/react';
import {
  banner_empretec,
  empretec_actor,
  empretec_candidate_text,
  empretec_graphics,
} from '../../../utils/images';
import { handleQuerySmall } from '../pages/candidate-interview/candidate-interview-styled';

export const BackgroundCandidate = styled.div`
  width: 100vw;
  height: max(945px, 100vh);
  max-width: ${BaSeTheme.breakpoints.desktop.maxWidth}px;

  background: url(${empretec_actor}) no-repeat left 0px top 0px,
    url(${empretec_graphics}) no-repeat left 0px top -60px,
    url(${banner_empretec}) no-repeat left 600px top 840px;

  ${handleQuerySmall(css`
    display: flex;
    justify-content: center;
    align-items: start;
    background: url(${banner_empretec}) no-repeat left 600px top 850px;
  `)}
`;

export const Wrapper = styled.div`
  max-width: 475px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 160px;
  padding-left: 750px;
  margin: 0 20px 20px 20px;

  ${handleQuerySmall(css`
    display: flex;
    align-items: center;
    margin-top: 24px;
    padding-top: 0px;
    padding-left: 0px;
  `)}
`;

export const ImageEmpretecText = styled.div`
  ${({ inDesktop }) =>
    !inDesktop
      ? css`
          width: 275px;
          height: 240px;
          background-image: url(${empretec_candidate_text});
          background-repeat: no-repeat;
        `
      : css`
          width: 275px;
          height: 240px;
        `}
`;

export const WrapperButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;

  ${handleQuerySmall(css`
    width: 100%;
  `)}
`;
